// removed by extract-text-webpack-plugin
module.exports = {"title":"Methodology__title__23zQO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Methodology/Methodology.css
// module id = 562
// module chunks = 0